// extracted by mini-css-extract-plugin
module.exports = {"title":"p","papyrus":"q"};